'use strict';

var _ = require('lodash');
function FaresOptimizerFilingLadderFilterService() {
  function areThereProductsForFiling(ladder) {
    return ruleOrFootnoteChanged(ladder) || areThereAnyFaresForFiling(ladder);
  }
  function ruleOrFootnoteChanged(ladder) {
    return ladder.isRuleUpdated === true || ladder.isFootnoteUpdated === true || ladder.isAdvancePurchaseUpdated === true || ladder.isDiscontinueRule === true;
  }
  function areThereAnyFaresForFiling(ladder) {
    if (_.isUndefined(ladder.groupedRows)) {
      return false;
    }
    var recommendationsToBeIgnored = _.filter(ladder.groupedRows, function (row) {
      return shouldIgnoreRecommendationForSend(ladder, row);
    });
    return recommendationsToBeIgnored.length < ladder.groupedRows.length;
  }
  function shouldIgnoreRecommendationForSend(fareRecommendationLadder, fareRecommendation) {
    var inValidRecommendation = false;
    if ('TACTICAL' === fareRecommendationLadder.category) {
      inValidRecommendation = fareRecommendation.fbc === fareRecommendationLadder.hostHighestFbc;
    }
    return inValidRecommendation || fareRecommendation.actionCode === 'C' && (fareRecommendation.fareChangeAbsolute === 0.00 || fareRecommendation.effectiveFareChangeAbsolute === 0.00);
  }
  return {
    areThereProductsForFiling: areThereProductsForFiling
  };
}
FaresOptimizerFilingLadderFilterService.$inject = [];
module.exports = FaresOptimizerFilingLadderFilterService;